import { render, staticRenderFns } from "./TwCouponInformation.vue?vue&type=template&id=2d96e28a&scoped=true&"
import script from "./TwCouponInformation.vue?vue&type=script&lang=js&"
export * from "./TwCouponInformation.vue?vue&type=script&lang=js&"
import style0 from "./TwCouponInformation.vue?vue&type=style&index=0&id=2d96e28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96e28a",
  null
  
)

export default component.exports